import { render, staticRenderFns } from "./ProformDataTable.vue?vue&type=template&id=ee815f90&scoped=true"
import script from "./ProformDataTable.vue?vue&type=script&lang=js"
export * from "./ProformDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee815f90",
  null
  
)

export default component.exports